import storeCreator from 'shared/tools/store-creator'
import rootReducer from 'client/bookmate/reducers/root-reducer'

export default storeCreator(rootReducer)
